<template>
  <picture>
    <source :srcset="webpUrl" type="image/webp" />
    <source :srcset="url" type="image/jpeg" />
    <img :src="url" :class="className" />
  </picture>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    webpUrl() {
      return this.url ? `${this.url}?imageMogr2/format/webp` : this.url;
    }
  }
};
</script>
